@switch (displayMode()) {

    @case(DisplayMode.FullName)
    {
        <span [id]="department().id">{{ department().fullName()  }}</span>
    }

    @case (DisplayMode.Code) 
    {
        <span [id]="department().id">{{ department().code()  }}</span>
    }

    @case (DisplayMode.Name) 
    {
        <span [id]="department().id">{{ department().name()  }}</span>
    }
    

}


